// v3.69 — Sativa / Indica / Hybrid classification.
// Single source of truth for labels, colors, and option ordering across the
// app. Internal lowercase tokens; display labels with the dom-hybrid variants
// spelled out for collectors.
export const CLASSIFICATION_VALUES = [
  "sativa",
  "indica",
  "hybrid",
  "sativa_dominant",
  "indica_dominant",
  "unknown",
];

export const CLASSIFICATION_LABELS = {
  sativa: "Sativa",
  indica: "Indica",
  hybrid: "Hybrid",
  sativa_dominant: "Sativa-dominant Hybrid",
  indica_dominant: "Indica-dominant Hybrid",
  unknown: "Unknown / Not specified",
};

// Short label used in tight UI (cards, pills).
export const CLASSIFICATION_SHORT = {
  sativa: "Sativa",
  indica: "Indica",
  hybrid: "Hybrid",
  sativa_dominant: "Sativa-dom",
  indica_dominant: "Indica-dom",
  unknown: "—",
};

// Brand-restrained colour mapping. Sativa = warm gold-ish, Indica = deep
// violet, Hybrid = primary green; dom variants share their root colour at a
// slightly desaturated tone. Kept to CSS vars where possible.
export const CLASSIFICATION_COLOR = {
  sativa: "#E0B062",                    // warm gold
  indica: "#9b87f5",                    // violet
  hybrid: "var(--primary-text)",        // brand green
  sativa_dominant: "#C99A55",
  indica_dominant: "#7E6FCB",
  unknown: "var(--text-muted)",
};

// Public-facing filter options (excludes "unknown" since users don't usually
// want to filter TO unknown — admin tools still get it via the editor).
export const CLASSIFICATION_FILTER_OPTIONS = [
  { value: "sativa", label: "Sativa" },
  { value: "sativa_dominant", label: "Sativa-dominant" },
  { value: "hybrid", label: "Hybrid" },
  { value: "indica_dominant", label: "Indica-dominant" },
  { value: "indica", label: "Indica" },
];

export function classificationLabel(value) {
  return CLASSIFICATION_LABELS[value] || CLASSIFICATION_LABELS.unknown;
}

export function classificationShort(value) {
  return CLASSIFICATION_SHORT[value] || "—";
}

export function classificationColor(value) {
  return CLASSIFICATION_COLOR[value] || CLASSIFICATION_COLOR.unknown;
}
